import { call, take, takeLatest } from "redux-saga/effects";
import { MANAGE_ORDER_DETAIL, MANAGE_ORDER_LIST } from "../actions/types";
import * as manageOrderApis from "../apis/manageOrderApis";

export function* manangeOrderListWorker(action) {
  try {
    const res = yield call(manageOrderApis.orderList, action.data);
    if (res.status == "200") {
      console.log(action);
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* manageOrderDetailWorker(action) {
  try {
    const res = yield call(manageOrderApis.orderDetail, {
      order_id: action.id,
    });
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* manangeOrderListWatcher() {
  yield takeLatest(MANAGE_ORDER_LIST, manangeOrderListWorker);
}

export function* manageOrderDetailWatcher() {
  yield takeLatest(MANAGE_ORDER_DETAIL, manageOrderDetailWorker);
}
